import { request } from '@umijs/max';

export interface SupportExtraItem {
  id: string;
  label: string;
  icon: string;
  value: string;
  qr_url: string;
}

export interface SupportConfigResponse {
  enabled: boolean;
  display_position: 'header' | 'float' | 'both' | 'page_only';
  phone: { enabled: boolean; number: string };
  email: { enabled: boolean; address: string };
  wechat: { enabled: boolean; qr_url: string; label: string };
  qq: { enabled: boolean; number: string; qr_url: string; label: string };
  telegram: { enabled: boolean; link: string; qr_url: string; label: string };
  ticket_enabled: boolean;
  working_hours: { enabled: boolean; text: string };
  extra_info: SupportExtraItem[];
}

export async function fetchSupportInfo(): Promise<SupportConfigResponse | null> {
  try {
    const res = await request('/api/v1/saas/public/support-info', { method: 'GET' });
    return res?.data ?? null;
  } catch {
    return null;
  }
}

export async function getSupportConfig(): Promise<SupportConfigResponse> {
  const res = await request('/api/v1/saas/tenant/support-config', { method: 'GET' });
  return res.data;
}

export async function saveSupportConfig(data: Partial<SupportConfigResponse>) {
  return request('/api/v1/saas/tenant/support-config', {
    method: 'PUT',
    data,
  });
}
